import React from 'react';
import { RelatedBlock } from './RelatedBlock';
import { MAX_ITEMS_WITH_TWO_BLOCKS } from '.';
import Head from 'next/head';

interface IRelatedVideosProps {
  relatedVideos: {
    seeMoreUrl?: string;
    title?: string;
    urls?: {
      url?: string;
      description?: string;
      thumbnailUrl?: string;
      name?: string;
      uploadDate?: number;
    }[];
  };
}
export const RelatedVideos = ({
  relatedVideos = { urls: [], seeMoreUrl: '' },
}: IRelatedVideosProps) => {
  return (
    <>
      {!!relatedVideos?.urls?.length && (
        <Head>
          {relatedVideos.urls.map((video, index) => {
            return (
              <script
                key={`${index}${video.url}`}
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                  __html: JSON.stringify({
                    '@context': 'https://schema.org',
                    '@type': 'VideoObject',
                    name: video.name,
                    description: video.description,
                    thumbnailUrl: video.thumbnailUrl,
                    uploadDate:
                      typeof video.uploadDate === 'number'
                        ? new Date(video.uploadDate * 1000).toISOString()
                        : '',
                    embedUrl: video.url,
                  }),
                }}
              />
            );
          })}
        </Head>
      )}
      <RelatedBlock
        type="video"
        seeMoreUrl={relatedVideos.seeMoreUrl}
        items={
          relatedVideos?.urls
            ?.slice(0, MAX_ITEMS_WITH_TWO_BLOCKS)
            .map(({ url, thumbnailUrl, name }) => {
              return {
                url: url || '',
                thumbnailUrl: thumbnailUrl || '',
                description: name || '',
              };
            }) || []
        }
      />
    </>
  );
};
